import {WIX_EVENTS_TICKET_DEFINITION_FQDN} from '@wix/wix-events-commons-statics'

export const getTicketDefinitionByExternalId = (tickets: wix.events.ticketing.TicketDefinition[], externalId: string) =>
  tickets.find(ticketDef => ticketDef.id === externalId?.replace(WIX_EVENTS_TICKET_DEFINITION_FQDN, ''))
